import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-608e2417"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "footer",
  class: "flex"
}
const _hoisted_2 = { class: "footer-content flex flex-column py-s6" }
const _hoisted_3 = { class: "flex flex-column sm:flex-row sm:justify-content-between align-items-start" }
const _hoisted_4 = { class: "flex flex-column sm:flex-row align-items-center mt-s10 w-full" }
const _hoisted_5 = {
  key: 0,
  class: "col"
}
const _hoisted_6 = { class: "col text-right sm:flex-order-3" }
const _hoisted_7 = { class: "col" }

import CommunityIcons from './CommunityIcons.vue';
import Copyright from './Copyright.vue';
import FooterMenu from './FooterMenu.vue';
import InfoPanel from './InfoPanel.vue';
import { useLayout } from '@/composables/core/useLayout';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { isMobile, isDesktop } = useLayout();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(InfoPanel, { class: "w-12 sm:w-auto sm:flex-order-2" }),
        _createVNode(FooterMenu, {
          class: _normalizeClass(["w-12 sm:w-auto xl:min-w-max", { 'mt-s10': _unref(isMobile) }])
        }, null, 8, ["class"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_unref(isDesktop))
          ? (_openBlock(), _createElementBlock("div", _hoisted_5))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(CommunityIcons)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(Copyright)
        ])
      ])
    ])
  ]))
}
}

})